import React, { useEffect } from 'react'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { useTranslation } from 'react-i18next'
import Cookies from 'js-cookie'
import { toastr } from 'react-redux-toastr'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Loader2, Link2, Link2Off } from 'lucide-react'
import { Query, Mutation } from '../../api'
import { API_URL } from '../../utils'
import AccountPageSkeleton from './AccountPageSkeleton'

const AccountPage: React.FC = () => {
  const { t } = useTranslation()
  const { data, loading, refetch } = useQuery(Query.ME)

  const [disconnect, { loading: disconnecting }] = useMutation(Mutation.DISCONNECT_MICROSOFT_ACCOUNT, {
    onCompleted: () => {
      toastr.success(t('Common_success'), t('Account_ms_disconnected'))
      refetch()
    },
    onError: (e) => toastr.error(t('Common_error'), e.message),
  })

  useEffect(() => {
    const p = new URLSearchParams(window.location.search)
    if (p.get('ms') === 'connected') {
      toastr.success(t('Common_success'), t('Account_ms_connected'))
      refetch()
    } else if (p.get('ms') === 'error') {
      toastr.error(t('Common_error'), t('Account_ms_connect_failed'))
    }
  }, [refetch, t])

  if (loading) return <AccountPageSkeleton />

  const me = data?.me || {}
  const connectUrl = `${API_URL}/auth/microsoft/start?token=${Cookies.get('token') || ''}`

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">{t('Account_title')}</h1>
      <Card>
        <CardHeader>
          <CardTitle>{t('Account_connected_accounts')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between gap-4">
            <div>
              <div className="font-medium">{t('Account_ms_teams')}</div>
              <div className="text-sm text-muted-foreground">
                {me.microsoftConnected ? me.microsoftAccountEmail : t('Account_ms_not_connected')}
              </div>
            </div>
            {me.microsoftConnected ? (
              <Button variant="outline" size="sm" onClick={() => disconnect()} disabled={disconnecting}>
                {disconnecting ? <Loader2 className="h-4 w-4 animate-spin" /> : <Link2Off className="h-4 w-4" />}
                {t('Account_disconnect')}
              </Button>
            ) : (
              <Button size="sm" onClick={() => (window.location.href = connectUrl)}>
                <Link2 className="h-4 w-4" />
                {t('Account_connect')}
              </Button>
            )}
          </div>
          <p className="text-xs text-muted-foreground">{t('Account_google_meet_soon')}</p>
        </CardContent>
      </Card>
    </div>
  )
}

export default AccountPage
